import $ from "jquery";

class Search {
  constructor() {
    this.addSearchHTML();
    this.searchResults = $(".search-results");
    this.searchOverlay = $(".search-overlay");
    this.closeButton = $(".search-close-btn");
    this.searchField = $("#search");
    this.typingTimer;
    this.isSpinnerVisible = false;
    this.events();
    this.setAllActive();

    // Optional: map data-filter → default term if no data-term is provided
    this.filterMap = {
      native: "Native Planting",
      tropical: "Tropical Garden",
      coastal: "Coastal Garden Design",
      "bird-attracting": "Bird-attracting",
    };

    this.events();
  }

  events() {
    // existing
    this.searchField.on("input", this.typingLogic.bind(this));
    this.searchField.on("blur", this.checkIfEmpty.bind(this));
    this.closeButton.on("click", this.closeOverlay.bind(this));

    $(document).on("keydown", (e) => {
      if (e.key === "Escape") this.closeOverlay();
    });

    $(document).on("click", (e) => {
      // Ignore clicks on filter chips/filters area
      if ($(e.target).closest(".filter-btn, .filters").length) return;

      const isClickInside =
        this.searchOverlay[0].contains(e.target) ||
        this.searchResults[0].contains(e.target) ||
        this.searchField[0].contains(e.target);

      if (!isClickInside) this.closeOverlay();
    });

    // NEW: delegate clicks from any .filter-btn (works even if DOM is re-rendered)
    $(document).on("click", ".filter-btn", this.handleFilterClick.bind(this));
  }

  // NEW
  handleFilterClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const $btn = $(e.currentTarget);
    const filter = $btn.data("filter");

    // Manage active state here
    $(".filter-btn").removeClass("active");
    $btn.addClass("active");

    // Special case: "All" clears search & closes overlay
    if (filter === "all") {
      this.searchField.val("");
      this.closeOverlay();
      return;
    }

    // Prefer data-term, else filterMap, else button text
    const term =
      $btn.data("term") || this.filterMap[filter] || $btn.text().trim();

    // Hold Cmd/Ctrl to append; otherwise replace
    if (e.metaKey || e.ctrlKey) {
      const current = this.searchField.val().trim();
      this.searchField.val((current ? current + " " : "") + term);
    } else {
      this.searchField.val(term);
    }

    // Trigger your existing search flow
    this.searchField.trigger("input").focus();
  }

  setAllActive() {
    $(".filter-btn").removeClass("active");
    $('.filter-btn[data-filter="all"]').addClass("active");
  }

  lockScroll() {
    // Save current scroll position
    this._scrollY = window.scrollY || window.pageYOffset;

    // Prevent layout shift from scrollbar disappearing
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--sbw", sbw + "px");

    // Lock the page
    document.documentElement.classList.add("no-scroll");
    document.body.style.position = "fixed";
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.paddingRight = sbw ? sbw + "px" : "";
  }

  unlockScroll() {
    // Unlock
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.paddingRight = "";
    document.documentElement.classList.remove("no-scroll");
    document.documentElement.style.removeProperty("--sbw");

    // Restore scroll
    if (typeof this._scrollY === "number") {
      window.scrollTo(0, this._scrollY);
    }
  }

  typingLogic() {
    clearTimeout(this.typingTimer);

    if (this.searchField.val().trim() === "") {
      this.closeOverlay();
      return;
    }

    this.openOverlay();

    if (!this.isSpinnerVisible) {
      this.searchResults.html('<div class="spinner-loader"></div>');
      this.isSpinnerVisible = true;
    }

    this.typingTimer = setTimeout(this.getResults.bind(this), 750);
  }

  checkIfEmpty() {
    if (this.searchField.val().trim() === "") this.closeOverlay();
  }

  openOverlay() {
    this.searchOverlay.addClass("search-overlay-active");
    $("html, body").addClass("body-no-scroll");
    $('.filter-btn[data-filter="all"]').removeClass("active");
    this.lockScroll(); 
  }

  closeOverlay() {
    this.searchResults.html("");
    this.isSpinnerVisible = false;
    this.searchOverlay.removeClass("search-overlay-active");
    $("html, body").removeClass("body-no-scroll");
    this.unlockScroll(); 
    this.searchField.val("");
    this.setAllActive();
  }

  getResults() {
    $.getJSON(
      siteData.root_url +
        "/wp-json/wp/v2/posts?search=" +
        this.searchField.val(),
      (posts) => {
        this.searchResults.html(`
          <h2 class="search-results-title">Search Results</h2>
          ${
            posts.length
              ? '<ul class="search-results-list">'
              : '<p class="no-results">No results match that search.</p>'
          }
          ${posts
            .map(
              (item) =>
                `<li class="search-results-item"><a href="${item.link}">${item.title.rendered}</a></li>`
            )
            .join("")}
          ${posts.length ? "</ul>" : ""}
        `);
        this.isSpinnerVisible = false;
      }
    );
  }

  addSearchHTML() {
    $("body").append(`
      <div class="search-overlay">
        <div class="search-top">
          <i class="fa fa-window-close search-btn search-close-btn" aria-hidden="true"></i>
        </div>
        <div class="search-results"></div>
      </div>
    `);
  }
}

export default Search;
